// extracted by mini-css-extract-plugin
export var root = "Heading-module--root--20zzr";
export var header = "Heading-module--header--KCmwE";
export var headerWord = "Heading-module--headerWord--3s6Et";
export var headerWordAnimation = "Heading-module--headerWordAnimation--2vpvD";
export var mobile = "Heading-module--mobile--2bUmd";
export var light = "Heading-module--light--2TPNs";
export var dark = "Heading-module--dark--1vmuo";